import { useContext } from 'react'
import { WalletContext } from '../providers/WalletProvider'

export default function useWallet() {
  return useContext(WalletContext)
}
